<script>
import appConfig from '@src/app.config'
import scrollEvent from '@utils/scroll-animation.js'
import PageHeader from "@components/page-header.vue";
import ModalContainer from "@components/modal-container.vue";
import ModalWindows from "@components/modal-windows.vue";
import Contacts from "@components/contacts.vue";
import MainScreenSection from "@components/sections/main-screen.vue";
import DataPresentationSection from "@components/sections/data-presentation.vue";
import IndustriesSection from "@components/sections/industries.vue";
import ServicesSection from "@components/sections/services.vue";
import HowItWorksSection from "@components/sections/how-it-works.vue";
import InvestmentSection from "@components/sections/investment.vue";
import JustTrySection from "@components/sections/just-try.vue";
import ArticlesSection from "@components/sections/articles.vue";
import QuestionSection from "@components/sections/question.vue";
import FaqSection from "@components/sections/faq.vue";
import DocumentsSection from "@components/sections/documents.vue";
import FullSiteFooter from '@components/full-site-footer.vue'
import CookiesWarning from '@components/elements/cookies-warning.vue'
import Layout from '@layouts/main.vue'
import {mapGetters} from "vuex";
import OneTimeReports from "@components/sections/one-time-reports.vue";
import VideoWidget from "@components/elements/video-widget.vue";

export default {
    name: 'Home',
    page: {
        title: appConfig.home.title,
        meta: [{name: 'description', content: appConfig.home.description}],
        link: [{ rel: 'canonical', href: appConfig.home.canonical }]
    },
    components: {
        VideoWidget,
        OneTimeReports,
        PageHeader,
        ModalContainer,
        ModalWindows,
        Contacts,
        MainScreenSection,
        DataPresentationSection,
        IndustriesSection,
        ServicesSection,
        HowItWorksSection,
        InvestmentSection,
        JustTrySection,
        ArticlesSection,
        QuestionSection,
        FaqSection,
        DocumentsSection,
        FullSiteFooter,
        CookiesWarning,
        Layout,
    },
    data() {
        return {
            windowsWidth: window.innerWidth,
            justTryBlockData: {
                serviceName: 'Оцените возможности Геоэффект',
                imgNum: 1,
            },
            videoData: {
                id: 'geoeffect-video',
                poster: '/assets/images/landing/transparent.png',
                sources: [
                    {
                        src: '/assets/files/geoeffect.mp4',
                        type: 'video/mp4;codecs="avc1.42E01E, mp4a.40.2"',
                    },
                    {
                        src: '/assets/files/geoeffect.webm',
                        type: 'video/webm; codecs="vorbis,vp8"',
                    },
                ],
            },
            services: [
                {
                    title: 'Цифровой житель',
                    description: 'Оцените спрос на инфраструктуру с помощью данных о профиле, численности и плотности населения',
                    background: 'tab-map',
                    link: 'citizen',
                },
                {
                    title: 'Цифровой туризм',
                    description: 'Повышайте потенциал туристической отрасли, анализируя турпоток в регионе',
                    background: 'tab-tourism',
                    link: 'tourist',
                },
                {
                    title: 'Посещаемость',
                    description: 'Анализ событий и мероприятий, исследуйте посещаемость объектов и территорий, отслеживайте динамику изменений',
                    background: 'tab-visiting',
                    link: 'visiting',
                },
                {
                    title: 'Геоэффект бизнес',
                    description: 'Выбирайте лучшие места для открытия новых точек продаж и развития сети. Сравнивайте и анализируйте трафик и конкурентов',
                    background: 'tab-geo',
                    link: 'business',
                },
            ],
            mobileNavigationBg: false,
            headerLinks: [
                {
                    text: 'Цифровой житель',
                    external: false,
                    link: 'citizen',
                    analyticsLabel: 'cifrovoi_zhitel',
                },
                {
                    text: 'Цифровой туризм',
                    external: false,
                    link: 'tourist',
                    analyticsLabel: 'cifrovoi_turizm',
                },
                {
                    text: 'Посещаемость',
                    external: false,
                    link: 'visiting',
                    analyticsLabel: 'poseschaemost',
                },
                {
                    text: 'Геоэффект бизнес',
                    external: false,
                    link: 'business',
                    analyticsLabel: 'geoeffekt_biznes',
                },
                {
                    text: 'Документация',
                    external: false,
                    link: null,
                    analyticsLabel: 'dokumentaciya',
                },
            ],
        }
    },
    created() {
        window.addEventListener("scroll", scrollEvent);
        window.addEventListener('resize', this.onResize);
    },
    beforeDestroy() {
        window.addEventListener('resize', this.onResize);
        document.body.style.overflow = 'visible';
    },
    computed: {
        ...mapGetters({
            getActiveModalWindow: 'modal/getActiveModalWindow',
        }),
        isMobile() {
            return this.windowsWidth <= 1000;
        }
    },
    methods: {
        onResize() {
            this.windowsWidth = window.innerWidth;
        },
    },
}
</script>

<template>
    <Layout class="landing-page">
        <PageHeader
            :links="headerLinks"
            :logo-link="false"
            :is-mobile="isMobile"
            :show-login-button="true"
        />

<!--        <ModalContainer />-->

        <ModalWindows
            :open-window="getActiveModalWindow"
        />

        <Contacts />

        <div id="main-page" class="city-map">
            <MainScreenSection />
            <DataPresentationSection />
            <OneTimeReports position="top" />
            <VideoWidget
                :id="videoData.id"
                :poster="videoData.poster"
                :sources="videoData.sources"
            />
        </div>

        <IndustriesSection />

        <ServicesSection :services="services" />

        <HowItWorksSection />

<!--        <InvestmentSection />-->

        <JustTrySection
            :img-num="justTryBlockData.imgNum"
            :service-name="justTryBlockData.serviceName"

        />

        <ArticlesSection />

        <OneTimeReports position="bottom" />

        <FaqSection />

        <QuestionSection />

        <DocumentsSection />

        <CookiesWarning />
    </Layout>
</template>

<style lang="scss">
    @import '@design/components/header.scss';
    @import '@design/components/full-site-footer.scss';
    @import '@design/landing.scss';
</style>

